export default ["person", "bicycle", "car", "motorbike", "truck", "cat", "dog", "knife"]